export const FEATURED_BANNER_TOP = 'FeaturedBannerTop';
export const FEATURED_BANNER_2ND = 'FeaturedBanner2nd';
export const FEATURED_BANNER_3RD = 'FeaturedBanner3rd';
export const FEATURED_BANNER_4TH = 'FeaturedBanner4th';
export const LISTEN_BANNER_TOP = 'ListenBannerTop';
export const PERSONALITIES_BANNER_TOP = 'PersonalitiesBannerTop';
export const SHOWS_BANNER_TOP = 'ShowsBannerTop';
